





















































































































































































































































































































































































































































































































































import { mapActions, mapGetters } from "vuex";
import { App, General } from "@/utils/constants";
import { USER_PERMISSIONS as userPermissions } from "@/utils/enumerate";
import ModalWarning from "@/views/App/ModalWarning";
import ModalUserDetails from "@/views/App/ModalUserDetails";
import ModalProfileList from "@/views/App/ModalProfileList";
import { ICapacityStandardize, IProfile } from "@/store/types/control-types";
import { IBond } from "@/store/types/user-types";

interface ISecondary {
  newCapacityName: string | null;
  newCapacityNameData: ICapacityStandardize;
  newProfiles: IProfile[];
}

export default {
  name: "User",
  props: {
    userId: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      App,
      General,
      userPermissions,
      primaryProfilesInput: {} as Record<number, IProfile[]>,
      secondaryProfilesInput: {} as Record<number, IProfile[]>,
      newSecondaryProfilesInput: {} as ISecondary,
      filterTagTo: "",
      isLoading: false
    };
  },

  computed: {
    ...mapGetters({
      user: "getEditableUser",
      loggedUser: "getCurrentUser",
      hasPermission: "hasPermission",
      hasSomePermission: "hasSomePermission",
      getCapacitiesWithParamsFiltered: "getCapacitiesWithParamsFiltered",
      profilesByName: "getProfilesByName",
      isContrast: "isContrast",
      isMobile: "isMobile"
    }),

    wasSecondaryCapacityNameData() {
      return Boolean(
        this.newSecondaryProfilesInput.newCapacityNameData &&
          !Object.keys(this.newSecondaryProfilesInput.newCapacityNameData)
            .length
      );
    },

    hasSuiteAcess() {
      return this.user.bonds?.some(
        (bond: IBond) => bond.suite_access && !bond.is_secondary
      );
    },

    isAtUserProfileRoute() {
      return this.$router.currentRoute.fullPath.includes(
        "app/configuracoes-usuario"
      );
    },

    primaryBonds() {
      return this.user.bonds?.length
        ? this.user.bonds.filter((bond: IBond) => !bond.is_secondary)
        : [];
    },

    secondaryBonds() {
      return this.user.bonds?.length
        ? this.user.bonds.filter((bond: IBond) => bond.is_secondary)
        : [];
    },

    isEditable() {
      return (
        this.hasPermission(userPermissions["MANAGE_USER_ADM"]) ||
        this.hasPermission(userPermissions["MANAGE_USER_PART"]) ||
        this.hasPermission(userPermissions["MANAGE_USER_UNIT"])
      );
    },

    hasBondStatusPermission() {
      return (
        this.hasPermission(userPermissions["MANAGE_USER_ADM"]) ||
        this.hasPermission(userPermissions["MANAGE_USER_PART"]) ||
        this.hasPermission(userPermissions["MANAGE_USER_UNIT"])
      );
    },

    hasOnlyOneBondActive() {
      return (
        this.user.bonds?.reduce((acc: number[], profile: IBond) => {
          if (
            profile.suite_access &&
            profile.active &&
            !acc.includes(profile.user_profile_id)
          ) {
            acc.push(profile.user_profile_id);
          }
          return acc;
        }, [])?.length === 1
      );
    },

    checkFilledNewInput() {
      return (
        this.newSecondaryProfilesInput.newCapacityNameData?.part_id &&
        this.newSecondaryProfilesInput.newCapacityNameData?.capacity_id &&
        this.newSecondaryProfilesInput.newProfiles?.length
      );
    },

    hasPermissionAdmMaster() {
      return this.hasPermission(userPermissions["MANAGE_USER_ADM"]);
    },

    hasPermissionAdmPart() {
      return this.hasPermission(userPermissions["MANAGE_USER_PART"]);
    },

    hasPermissionAdmCapacity() {
      return this.hasPermission(userPermissions["MANAGE_USER_UNIT"]);
    },

    removeProfileIconColor() {
      return this.isContrast ? "is-white" : "is-warning";
    }
  },

  async beforeMount() {
    this.isLoading = true;
    await this.getUser();
    if (
      this.hasSomePermission([
        "MANAGE_USER_ADM",
        "MANAGE_USER_PART",
        "MANAGE_USER_UNIT"
      ])
    ) {
      await this.profileRequest({ simple: true });
    }
    if (this.hasPermissionAdmMaster) {
      await this.capacityWithParamsRequest();
    } else if (this.hasPermissionAdmPart) {
      await this.capacityWithParamsRequest({
        part_id: this.loggedUser.capacity.part_id
      });
    } else if (this.hasPermissionAdmCapacity) {
      await this.capacityWithParamsRequest({
        part_id: this.loggedUser.capacity.part_id,
        capacity_id: this.loggedUser.capacity.capacity_id
      });
    }
    this.isLoading = false;
  },

  methods: {
    ...mapActions({
      getDefaultByCapacity: "getDefaultByCapacity",
      capacityWithParamsRequest: "capacityWithParamsRequest",
      activeProfile: "activeProfile",
      userFilter: "userFilterAdmRequest",
      updateUserProfile: "updateUserProfile",
      saveUserProfile: "addUserProfile",
      profileRequest: "profileRequest"
    }),

    async setBoundStatus(bound: IBond, active: boolean) {
      this.isLoading = true;
      const result = await this.activeProfile({
        userProfileId: bound.user_profile_id,
        active,
        me: this.loggedUser.id === this.user.id
      });
      !result && (bound.active = !active);
      this.isLoading = false;
    },

    async getUser() {
      this.isLoading = true;
      const status = await this.userFilter({ id: this.userId });

      if (status) {
        this.primaryProfilesInput = {};
        this.secondaryProfilesInput = {};

        this.user.bonds?.forEach((bond: IBond) => {
          if (!bond.profiles) return;
          if (!bond.is_secondary) {
            this.primaryProfilesInput[bond.user_profile_id] = bond.profiles;
          } else {
            this.secondaryProfilesInput[bond.user_profile_id] = bond.profiles;
          }
        });
      } else {
        this.$router.push("/app");
      }
      this.isLoading = false;
    },

    capitalizeFirstLetter(string: string) {
      return string.charAt(0) + string.toLowerCase().slice(1);
    },

    disableRemoveProfile(bond: IBond) {
      if (this.hasOnlyOneBondActive && bond.active) return true;
      return this.disableEditProfile(bond);
    },

    disableEditProfile(bond: IBond) {
      if (this.hasPermission(userPermissions["MANAGE_USER_ADM"])) return false;
      if (this.hasPermission(userPermissions["MANAGE_USER_PART"]))
        return bond.part_id !== this.loggedUser.capacity.part_id;
      if (this.hasPermission(userPermissions["MANAGE_USER_UNIT"]))
        return !(
          bond.capacity_id === this.loggedUser.capacity.capacity_id ||
          bond.over_unit_id === this.loggedUser.capacity.capacity_id
        );
      return true;
    },

    setFilterTagTo(text: string) {
      this.filterTagTo = text;
    },

    formatOrganEntity(bond: IBond) {
      if (!bond.part_abbreviation) return "";
      const capacity_abbreviation = `${bond.part_abbreviation}/${
        bond.capacity_abbreviation.includes("/")
          ? bond.capacity_abbreviation.split("/")[1]
          : bond.capacity_abbreviation
      }`.toUpperCase();
      return `${capacity_abbreviation} - ${bond.capacity_description}`;
    },

    clearNewSecondaryProfilesInputs() {
      this.newSecondaryProfilesInput = {
        newCapacityName: null,
        newCapacityNameData: {} as ICapacityStandardize,
        newProfiles: []
      };
    },

    removeNewSecondaryProfilesInputs() {
      this.newSecondaryProfilesInput = {} as ISecondary;
    },

    async addUserProfile(profileId?: number, isSecondary?: boolean) {
      let userProfile = null;

      if (profileId) {
        const actualBond = this.user.bonds.find(
          (bond: IBond) => bond.user_profile_id === profileId
        );
        if (!actualBond) return;
        const { part_id, capacity_id } = actualBond;
        const profiles = isSecondary
          ? this.secondaryProfilesInput[profileId]
          : this.primaryProfilesInput[profileId];

        userProfile = {
          part_id,
          capacity_id,
          profiles,
          is_secondary: isSecondary
        };

        await this.updateUserProfile({
          user: this.user,
          userProfileId: profileId,
          userProfile
        });
      } else {
        const secondaryProfilesInputCapacity = this.newSecondaryProfilesInput
          ?.newCapacityNameData;
        userProfile = {
          part_id: secondaryProfilesInputCapacity?.part_id,
          capacity_id: secondaryProfilesInputCapacity?.capacity_id,
          profiles: this.newSecondaryProfilesInput?.newProfiles,
          is_secondary: true
        };

        if (this.checkFilledNewInput) {
          await this.saveUserProfile({
            user: this.user,
            userProfile
          });
        }
        this.clearNewSecondaryProfilesInputs();
      }

      await this.getUser();
    },

    callDialog(profileId: number) {
      this.$buefy.modal.open({
        parent: this as any,
        component: ModalWarning,
        props: {
          title: this.General.CONFIRM,
          message: `${this.General.MESSAGES.ARE_YOU_SURE_YOU_WANT_DELETE_CAPACITY_AND_DRAFTS}`,
          confirm: () => this.removeSecondaryCapacity(profileId),
          buttons: [
            { label: General.YES, isConfirm: false, action: true },
            { label: General.NO, isConfirm: true, action: false }
          ]
        },
        hasModalCard: true,
        trapFocus: true
      });
    },

    async removeSecondaryCapacity(profileId: number) {
      const actualBond = this.user.bonds.find(
        (bond: IBond) => bond.user_profile_id === profileId
      );
      if (!actualBond) return;
      const { part_id, capacity_id } = actualBond;
      const userProfile = {
        part_id,
        capacity_id
      };

      await this.$store.dispatch("deleteUserProfile", {
        userId: this.user.id,
        userProfile
      });

      await this.getUser();
    },

    setSecondaryCapacityNameData(option: ICapacityStandardize) {
      if (option) this.newSecondaryProfilesInput.newCapacityNameData = option;
      else
        this.newSecondaryProfilesInput = {
          newCapacityName: null,
          newCapacityNameData: {} as ICapacityStandardize,
          newProfiles: []
        };
    },

    formatProfileNames(profileList: IProfile[]) {
      return profileList?.map(tag => tag?.name ?? "")?.join(", ");
    },

    async getDefaultProfile(
      bond: ICapacityStandardize,
      profileId?: number,
      profilePermissions?: IProfile[]
    ) {
      const data = { defaultProfile: {}, addDefault: {} };
      const refDefault = profilePermissions?.find((profile: IProfile) =>
        profile.name.match(/Default/)
      );

      if (!refDefault && bond.capacity_id) data.addDefault = bond;

      const capacityId =
        this.newSecondaryProfilesInput.newCapacityNameData?.id ??
        this.user.bonds.find(
          (bond: IBond) => bond.user_profile_id === profileId
        )?.capacity_id;

      if (refDefault) data.defaultProfile = refDefault;
      else if (capacityId) {
        this.isLoading = true;
        const request = await this.getDefaultByCapacity(capacityId);
        if (request.kind === "ok") data.defaultProfile = request.data;
        this.isLoading = false;
      }

      return data;
    },

    async openModalProfile(
      bond: ICapacityStandardize & { user_profile_id?: number },
      isSecondaryListed = false
    ) {
      const profileId = bond.user_profile_id;
      let profilePermissions = null;
      if (!profileId)
        profilePermissions = this.newSecondaryProfilesInput?.newProfiles;
      else {
        profilePermissions = isSecondaryListed
          ? this.secondaryProfilesInput[profileId]
          : this.primaryProfilesInput[profileId];
      }

      const { addDefault, defaultProfile } = await this.getDefaultProfile(
        bond,
        profileId,
        profilePermissions
      );

      this.$buefy.modal.open({
        parent: this as any,
        component: ModalProfileList,
        props: {
          partId: bond.part_id,
          permissions: profilePermissions || [],
          defaultProfile,
          addDefault,
          confirm: (newProfiles: IProfile[]) => {
            if (!profileId) {
              this.newSecondaryProfilesInput = {
                ...this.newSecondaryProfilesInput,
                newProfiles
              };
            } else if (isSecondaryListed) {
              this.secondaryProfilesInput[profileId] = newProfiles;
            } else {
              this.primaryProfilesInput[profileId] = newProfiles;
            }
            if (profileId) this.addUserProfile(profileId, isSecondaryListed);
          },
          listAll: this.hasPermission(userPermissions["MANAGE_USER_ADM"])
        },
        hasModalCard: true,
        trapFocus: true
      });
    },

    showModalDetails(title: string, details: string[]) {
      this.$buefy.modal.open({
        parent: this as any,
        component: ModalUserDetails,
        props: {
          title,
          details
        },
        hasModalCard: true,
        trapFocus: true
      });
    },

    listUsers() {
      this.$router.push({
        path: `/app/admin/busca-usuario/`,
        query: { keepList: "true" }
      });
    }
  }
};
